import Navbar from "../components/Navbar";
import Order from "../components/Order";
import Footer from "../components/Footer";
import { useContext, useEffect } from "react";
import { CarbonContext } from "../CarbonContext";
import { useNavigate } from "react-router-dom";

const Orders = () => {
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token.access_token) {
      navigate("/");
    }
  }, [token, navigate]);
  return (
    <>
      <Navbar />
      <Order />
      <Footer />
    </>
  );
};

export default Orders;
